import React from 'react'
import i18n from 'i18next'
import Button from './Button'
import Modal from './Modal'
import './styles/deleteModal.scss'

const DeleteModal = (props) => {
    const {
        show,
        onClose,
        onDelete,
        headerText,
        content,
        icon,
        noLabel,
        yesLabel,
        cssClass,
    } = props
    return (
        <Modal
            show={show}
            onClose={onClose}
        >
            <div id="delete-modal" className={cssClass}>
                <div className="form-header">
                    <div className="delete-warning-icon">
                        <i className={icon || 'fal fa-exclamation-circle'} />
                    </div>
                    <h2>{headerText}</h2>
                    <div>
                        <p className="desc" dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                </div>
                <div className="delete-button-panel">
                    <Button
                        onClick={onClose}
                        cssClass="regular tertiary"
                        label={noLabel || i18n.t('delete_modal_onClose_label', 'No - return to page')}
                    />
                    <Button
                        onClick={onDelete}
                        cssClass="regular error"
                        label={yesLabel || i18n.t('delete_modal_onDelete_label', 'Yes - Delete question')}
                        icon="fa-light fa-circle-xmark"
                    />
                </div>
            </div>

        </Modal>
    )
}

export default DeleteModal
